const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90vw",
  height: "90vh",
  bgcolor: "#ffffff",
  border: "1px solid #000",
  boxShadow: 24,
  px: 4,
  py: 2,
  spacing: 2,
  borderRadius: 1,
  overflowY: "scroll",
  maxHeight: "100%",
};

export default style2;
